function hasNoReason (settings, store) {
    return store.getState()
        [settings.stateLocations.Survey.Base]
        [settings.stateLocations.Survey.Reason] === "";
}

function hasNoComment (settings, store) {
    return store.getState()
        [settings.stateLocations.Survey.Base]
        [settings.stateLocations.Survey.Comment] === "";
}

export { 
    hasNoReason,
    hasNoComment
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/simple-feedback-overlay/src/util/util.js